import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const loginData = localStorage.getItem('loginData');
    const loginExpiry = localStorage.getItem('loginExpiry');

    if (loginData && loginExpiry) {
      const expiryTime = parseInt(loginExpiry, 10);
      if (Date.now() < expiryTime) {
        return true;
      }
    }

    // Session missing or expired — clear and redirect to login
    localStorage.removeItem('loginData');
    localStorage.removeItem('loginExpiry');
    localStorage.removeItem('userProfile');
    this.router.navigate(['/login']);
    return false;
  }
}
